<template>
  <CMSComponent v-if="resource" :resource="resource">
    <component :is="blockName" :resource="resource">
      <template v-if="resource.filteredChildren && resource.filteredChildren.length">
        <Blocks v-for="child in resource.filteredChildren" :key="child.id" :resource="child" />
      </template>
    </component>
  </CMSComponent>
</template>

<script>
import blocksConfig from '@/blocks.config'
import blocksMixin from '../mixins/blocks-mixin'
import CMSComponent from "./cms-component";
import Unknown from './unknown'

export default {
  name: 'Blocks',
  components: {
    CMSComponent,
    Unknown,
    ...blocksConfig.blocks,
  },
  mixins: [ blocksMixin ]
}
</script>
